"use strict"

import React, {useEffect, useState} from "react"
import {observer} from "mobx-react"
import {injectIntl, FormattedMessage} from "react-intl"
import MobxReactForm from "mobx-react-form"
import validatorjs from "validatorjs"
import dvr from "mobx-react-form/lib/validators/DVR"

import {Grid, Paper, Container, Typography, Link, Box} from "@material-ui/core"

import XsInput from "../../global/ui/xsInput/xsInput"
import XsButton from "../../global/ui/xsButton/xsButton"

import {isPasswordValid} from "../../global/helpers/functions"

import GlobalStore from "../../global/store/GlobalStore"
import RouterStore from "../../global/store/RouterStore"
import LoginStore from "./loginStore"
import XsPublicHeader from "../../global/ui/xsHeader/xsPublicHeader"

function ResetPasswordContainer() {
	const hooks = {
		onSubmit(form) {
			const {password, conf_psw} = form.values()

			if (isNotEmpty(password) && password != conf_psw) {
				GlobalStore.setNotificationMessage("Heslo a potvrdenie hesla sa musia zhodovať!", "", "warning")
				form.$("password").invalidate()
			} else if (!isPasswordValid(password) || !isPasswordValid(conf_psw)) {
				GlobalStore.setNotificationMessage(
					"Heslo musí obsahovať aspoň jedno veľké písmeno, jedno malé písmeno a jednu číslicu. Minimálna dĺžka hesla je 8 znakov.",
					"",
					"warning"
				)
				form.$("password").invalidate()
			}
		},
		onSuccess(form) {
			LoginStore.handleResetPasswordFinish(form)
		},
		onError() {
			GlobalStore.setNotificationMessage("Skontrolujte povinné polia!", "", "warning")
		}
	}

	const [form] = useState(
		new MobxReactForm(
			{
				fields: {
					password: {
						label: "Nové heslo"
					},
					conf_psw: {
						label: "Potvrdenie hesla"
					}
				}
			},
			{plugins: {dvr: dvr(validatorjs)}, hooks}
		)
	)

	useEffect(() => {
		LoginStore.token = new URLSearchParams(RouterStore.location.search).get("token")
	}, [])

	return (
		<React.Fragment>
			<XsPublicHeader />
			<Container maxWidth="lg">
				<Grid container justify="center">
					<Grid item style={{maxWidth: "450px", width: "450px"}}>
						<Grid container direction="column" justify="center" style={{height: "65vh"}}>
							<Grid container direction="column" spacing={3}>
								<Grid item className="textCenter">
									<Typography variant="h3">Nastavenie hesla</Typography>
								</Grid>
								<Grid item>
									<Paper variant="elevation" elevation={2} style={{backgroundColor: "transparent"}}>
										<Box p={2}>
											<Grid item container direction="column" spacing={2}>
												<Grid item>
													<Typography variant="body2">
														<span className="bold">Heslo musí spĺňať nasledovné kritériá:</span>
														<ul>
															<li>musí obsahovať aspoň jedno VEĽKÉ písmeno</li>
															<li>musí obsahovať aspoň jedno malé písmeno</li>
															<li>musí obsahovať aspoň jedno číslo</li>
															<li>musí obsahovať aspoň jeden špeciálny znak</li>
															<li>dĺžka hesla musí byť minimálne 8 znakov a maximálne 50 znakov</li>
														</ul>
													</Typography>
													<Typography variant="body2">
														Môžete si vytvoriť vlastné heslo alebo si ho nechať vygenerovať prehliadačom.
													</Typography>
												</Grid>
												<Grid item>
													<XsInput
														regex={(val) => isPasswordValid(val)}
														type="password"
														field={form.$("password")}
														autoFocus={true}
														submitAction={(e) => form.onSubmit(e)}
													/>
												</Grid>
												<Grid item>
													<XsInput
														regex={(val) => isPasswordValid(val)}
														type="password"
														field={form.$("conf_psw")}
														submitAction={(e) => form.onSubmit(e)}
													/>
												</Grid>
												<Grid item>
													<XsButton text={<FormattedMessage id="Common.label.resetPsw" />} onClick={form.onSubmit} />
												</Grid>
												<Grid item>
													<Link
														variant="body2"
														className="pointer"
														onClick={() => {
															LoginStore.screen = LoginStore.screens.LOGIN
															RouterStore.push("./login")
														}}
													>
														Prihlásiť sa
													</Link>
												</Grid>
											</Grid>
										</Box>
									</Paper>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Container>
		</React.Fragment>
	)
}

export default injectIntl(observer(ResetPasswordContainer))

